import { useState } from 'react';
import './CountryFlag.css';

type CountryFlagProps = {
   isoCode: string;
   size?: number;
   className?: string;
};

export function CountryFlag({ isoCode, size = 24, className = '' }: CountryFlagProps) {
   const [hasError, setHasError] = useState(false);

   const countryCode = isoCode.toLowerCase();
   const flagUrl = `https://flagcdn.com/w40/${countryCode}.png`;

   if (hasError || !isoCode) {
      return (
         <div
            className={`country-flag-placeholder ${className}`}
            style={{
               width: `${size}px`,
               height: `${size * 0.75}px`,
            }}
         />
      );
   }

   return (
      <img
         src={flagUrl}
         alt={`${isoCode} flag`}
         className={`country-flag ${className}`}
         style={{
            width: `${size}px`,
            height: `${size * 0.75}px`,
         }}
         onError={() => setHasError(true)}
      />
   );
}
